import React from 'react'
import './SmartSavingOptInScreen.css'
import { useTranslation } from 'react-i18next';
import Loader from '../../../../components/shared/loader/Loader';

const SmartSavingOptInScreen = (props) => {
  const { onConsentSelected, putConsentLoading } = props
  const { t } = useTranslation(["translation"]);

  const handleUserConsent = (consent) => {
    onConsentSelected(consent);
  }

  return (
    < div className='smart-saving-opt-in-screen-container'>
      { (putConsentLoading) &&
        <div className={`loader-overlay-wrapper`}>
          <Loader setOverlay={false} isHarwareInclusive={true}></Loader>
        </div>}
      <div className='smart-saving__content-wrapper'>
        <div className='smart-saving__content'>
          <div className='smart-saving__title'>{t("CONNECT_DASHBOARD.SMART_SAVING_OPT_IN.TITLE")}</div>

          <div className='smart-saving__subtitle'>
            {t("CONNECT_DASHBOARD.SMART_SAVING_OPT_IN.SUBTITLE")}
          </div>

          <div className='smart-saving__info'>
            {t("CONNECT_DASHBOARD.SMART_SAVING_OPT_IN.INFO")}
          </div>
        </div>
        {/* Commented out the code below temporarily until business confirmation on the gradient background image. */}        
        {/* <div className='smart-saving__image-wrapper'>
          <img src={OptInScreen} alt="smart-saving" />
        </div> */}
      </div>
      <div className='smart-saving-opt-in-btns-wrapper'>
        <button className="smart-saving__notify-btn" onClick={() => handleUserConsent(true)}>{t("CONNECT_DASHBOARD.SMART_SAVING_OPT_IN.NOTIFY_BTN")}</button>
        <button className="smart-saving__skip-btn" onClick={() => handleUserConsent(false)}>{t("CONNECT_DASHBOARD.SMART_SAVING_OPT_IN.SKIP_BTN")}</button>
      </div>
    </div>
  )
}

export default SmartSavingOptInScreen